const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupplier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-228"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.88,
    y: 390.34,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.78,
    y: 390.47,
    width: 41.14,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.76,
    y: 397,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 395.11,
    width: 51.67,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.71,
    y: 395.11,
    width: 34.39,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.29,
    y: 390.89,
    width: 46.84,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.78,
    y: 38.14,
    width: 139.29,
    height: 271.74,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102 309.89 65.67 309.89 65.67 147.53 102 135.66 102 309.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.33 309.89 96 309.89 96 186.42 132.33 174.55 132.33 309.89",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.99 182.97 119.32 182.97 119.32 153.51 127.99 150.68 127.99 182.97",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.06,
    y: 38.14,
    width: 139.29,
    height: 271.74,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.06,
    y: 213.37,
    width: 40.89,
    height: 96.52,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.94,
    y: 38.14,
    width: 139.29,
    height: 271.74,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.89 309.89 405.33 309.89 405.33 114.52 434.89 102.64 434.89 309.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.22 309.89 428.89 309.89 428.89 186.42 465.22 174.55 465.22 309.89",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335 309.88 407.66 309.88 407.66 213.89 335 204.66 335 309.88",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.89 182.97 456.55 182.97 456.55 153.51 460.89 150.68 460.89 182.97",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.71 190.06 442.38 190.06 442.38 160.6 446.71 157.76 446.71 190.06",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.56,229.22H73.11a0,0,0,0,1,0,0v80.67a0,0,0,0,1,0,0H45.78a0,0,0,0,1,0,0V240A10.78,10.78,0,0,1,56.56,229.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.76,
    y: 232.05,
    width: 36.31,
    height: 77.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.26 244.11 220.95 232.05 220.95 309.89 257.26 309.89 257.26 244.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.01 244.11 234.7 232.05 234.7 309.89 271.01 309.89 271.01 244.11",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.01 231.75 307.32 219.69 307.32 309.89 271.01 309.89 271.01 231.75",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.85 309.88 73.42 309.88 150.57 38.14 188 38.14 110.85 309.88",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.05 309.88 185.62 309.88 262.76 38.14 300.2 38.14 223.05 309.88",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.9 309.88 232.47 309.88 309.62 38.14 347.05 38.14 269.9 309.88",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360 309.88 341.29 309.88 418.44 38.14 437.15 38.14 360 309.88",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.84,333c10.8-57.92,39.26-85.1,63.48-98.94C151.12,256,135.34,331.91,110.84,333Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.17,328.44c-8-43.66-27.23-60.74-43.51-68C59.37,274.18,70.87,331.19,87.17,328.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.15,340c-3.08-62.8-27-90.37-48.51-103.61C72.16,258.65,77.74,340.85,101.15,340Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.15,334.61c5-63.1,31.68-92.63,55.4-107.62C134.77,250.83,126.55,333.55,101.15,334.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.09,344.48c8-64.82-9.69-103.88-27.63-127.36C92,248.74,82.92,334.32,105.09,344.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,324.76C150.19,287,175.52,278,195,277.08,174.39,284.24,146.78,333.18,130,324.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81,326.19c12.73-42.79,36.83-61,56.63-69.42C162.81,271.43,144.88,327.39,125.81,326.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.47,344.69C125.23,277.58,115.4,236.2,102.06,211,110.19,244.53,83,333.2,103.47,344.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.55,320.56v42.22c0,10.79,19.47,19.62,43.28,19.62h0c23.8,0,43.28-8.83,43.28-19.62V320.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,348.46c-2.39-39.83-19.54-58.52-34.93-68C379.11,295.51,383.35,347.73,400,348.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.64,345.35c9.22-30,23.9-41.78,35.68-46.78C440.37,308,427.57,347.23,416.64,345.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.07,353.3c7.53-43.18,26.29-62.14,42.17-71.24C433,297.35,422,353.87,406.07,353.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.54,349.59c2-43.4-13.7-63.7-28.65-74C390.75,292,389.23,348.86,406.54,349.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,356.37c.11-44.57,15.61-71.43,29.93-87.58C420.25,290.54,419.05,349.38,403,356.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.65,342.81c-10.59-26-27.16-32.16-40.42-32.79C360.72,314.94,375.41,348.6,387.65,342.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.37,343.8c-5-29.43-19.95-41.92-32.78-47.74C369.76,306.14,377.21,344.62,390.37,343.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.08,356.52c-9.11-46.15,1.2-74.6,12.51-91.92C408.13,287.64,419.06,348.61,404.08,356.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.26,340v29c0,7.41-13.37,13.47-29.71,13.47h0c-16.34,0-29.7-6.06-29.7-13.47V340Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-228"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-228",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-228"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "317.06 408.29 308.55 408.29 307.51 388.59 316.01 388.59 317.06 408.29",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.96 408.29 351.45 408.29 348.12 388.59 356.62 388.59 359.96 408.29",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.9,407.3h9.55a.7.7,0,0,1,.7.58l1.32,7.56a1.33,1.33,0,0,1-1.32,1.52c-3.33-.06-4.94-.26-9.15-.26-2.58,0-9.55.27-13.12.27s-3.87-3.53-2.4-3.85c6.63-1.43,10.82-3.41,13-5.29A2.17,2.17,0,0,1,350.9,407.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.34,407.3h9.28a.7.7,0,0,1,.7.58l1.32,7.56a1.31,1.31,0,0,1-1.3,1.52c-3.34-.06-8.18-.26-12.39-.26-4.92,0-6.17.27-11.95.27-3.49,0-4.29-3.53-2.81-3.85,6.72-1.45,9.15-1.61,15.06-5.15A4.1,4.1,0,0,1,308.34,407.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07,143.41,296.45,140s-11.84,28.13-15.85,30c-5.45,2.5-20,10.17-26.16,13.79-.42,1.39-.43,5.2.24,6.3,10.09-.8,30.79-7.65,34.77-11.47C298.53,169.9,308.07,143.41,308.07,143.41Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.59,138.1c3.3,7.36-19.36,39.64-19.36,39.64l-11-11.42s9.73-24.43,15-33.8C301.61,122.89,308,130,311.59,138.1Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.59,138.1c3.3,7.36-19.36,39.64-19.36,39.64l-11-11.42s9.73-24.43,15-33.8C301.61,122.89,308,130,311.59,138.1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.43,165.31c-.69.41-2.17,3.1-2.5,4.44s7.41,11.68,10.42,11.26,6.45-3.35,7.07-4.93S281.88,164.46,280.43,165.31Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.73,183.15l-7-1.28.42,10s2.46,1,7.76-2.28Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.27 185.2 241.55 191.35 249.1 191.91 248.68 181.88 240.27 185.2",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.51 388.6 308.05 398.75 316.55 398.75 316.02 388.6 307.51 388.6",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.63 388.6 348.12 388.6 349.84 398.75 358.35 398.75 356.63 388.6",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.78,128.06s-11.35,29.22-4.09,77.05h45.49c.64-7-2-44.59,6.27-77.49a116.05,116.05,0,0,0-15.14-1.93,168.51,168.51,0,0,0-19.34,0A87.78,87.78,0,0,0,300.78,128.06Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.78,128.06s-11.35,29.22-4.09,77.05h45.49c.64-7-2-44.59,6.27-77.49a116.05,116.05,0,0,0-15.14-1.93,168.51,168.51,0,0,0-19.34,0A87.78,87.78,0,0,0,300.78,128.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.18,135.74c-1,5.42.07,18.37,4.52,33.34a218.94,218.94,0,0,1,5-38.19v-.06C344.68,130.52,339.15,130.66,338.18,135.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.65,107.61c-1.52,6.22-2.49,13.93,1.66,18.08,0,0-2.8,6.32-14.36,6.32-10.57,0-5-6.32-5-6.32,7-1.65,7.07-10.23,6.09-15.07Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,132c6.81,2.13,8.16,4.31,8.16,4.31s8.49-3.45,8.17-10.93a17.11,17.11,0,0,0-3.32-1.92S331.29,129,319,132Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,132c-3.82.36-7,3.63-7,3.63s-2.43-2.55-.1-9.95c0,0,2.27-.77,4.15-1.17C316,124.52,314.47,130.4,319,132Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.06,110.63c.58,2.83.8,7-.54,10.21a11.44,11.44,0,0,0,3.15-1c4-1.84,6.06-4.75,8.28-9,.2-1.11.44-2.19.7-3.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.71,87.73c-2.72.89-8.8,6.11-3,8.74S323.45,86.19,318.71,87.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.06,100c-2.65,8.16-3.79,13-9,16.4-7.83,5-16.88-1-16.67-9.62.18-7.81,4.48-19.84,13.29-21.39S339.71,91.87,337.06,100Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.28,91.07c-4.5.76-8.25.52-9.61-3.22s4.83-7.66,9.1-5.9c3.15-3.28,11.75-.76,12.86,2.39,5-.32,9.73,5.44,6.34,8.39a5.94,5.94,0,0,1,1,9.31c1.46,4.34-3.8,8.67-7.95,6.91-4.09-1.22-6.32-.22-6.89-2.86s.87-5.19,4.35-5.7c-1.76-2.1-2.19-5.42-1-6.85C328.27,95.45,324.82,93.05,324.28,91.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.88,108.66a6.06,6.06,0,0,0,4.43-1.42.21.21,0,0,0,0-.29.19.19,0,0,0-.28,0,5.75,5.75,0,0,1-4.86,1.2.21.21,0,0,0-.24.16.18.18,0,0,0,.15.23A8,8,0,0,0,318.88,108.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.53,111.27a8.37,8.37,0,0,1-6,1.73c-2.79-.31-3-3.06-1.25-5.14,1.58-1.88,4.94-4,7.27-2.62S339.62,109.61,337.53,111.27Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.59,205.11s-1.16,10.7-2.64,25.19c-1.7,16.43-3.81,37.76-5.15,54,0,.08,0,.15,0,.22-.26,3.09-.49,6-.68,8.62-1.9,26.51,1.5,103.63,1.5,103.63H305.2s-13.28-78.7-12.95-105.68c.31-25.93,4.43-86,4.43-86Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.8,391.14c.07,0-.25,5.94-.25,5.94H303.94l-.42-6.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,230.3c-1.7,16.43-3.81,37.76-5.15,54,0,.08,0,.15,0,.22-3.17-15.41-4.16-34.57-2.93-66.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.82,205.11s6.64,61.46,10.77,85.81C328.12,317.59,346,396.78,346,396.78h15.58s-10.5-77-12.56-103.44c-2.22-28.66-6.81-88.23-6.81-88.23Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.77,391.5c.07,0,.54,5.58.54,5.58H345.19l-1.25-6.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.93,99.64c-.18.67-.67,1.14-1.1,1s-.64-.72-.47-1.39.67-1.14,1.1-1S323.1,99,322.93,99.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.45,98c-.18.67-.67,1.14-1.1,1s-.64-.71-.47-1.39.67-1.14,1.1-1S315.62,97.33,315.45,98Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,98.86a26.57,26.57,0,0,1-4.65,5.07c.88,1.36,3,1.29,3,1.29Z",
    style: {
      fill: "#630f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,97.68a.41.41,0,0,1-.27-.23,3,3,0,0,0-2.14-1.86.38.38,0,0,1-.32-.46.42.42,0,0,1,.47-.34,3.74,3.74,0,0,1,2.74,2.32.43.43,0,0,1-.22.54A.4.4,0,0,1,327,97.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,94.58a.6.6,0,0,1-.15-.09.4.4,0,0,1,0-.57,4.08,4.08,0,0,1,3.45-1.4.38.38,0,0,1,.32.46.43.43,0,0,1-.47.34h0a3.27,3.27,0,0,0-2.73,1.14A.44.44,0,0,1,314,94.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.49,139.23l-10.74,6.5s12,26,11.93,30.37c-.2,8.16,3.31,25.85,2.36,35.17,1.32.47,5,.58,6.16-.07,2.13-8.43,5.08-30.58,4.23-36.13C365.57,163,353.49,139.23,353.49,139.23Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.45,127.62c8,1.17,19.4,41.77,19.4,41.77L353.05,175S340.16,153,337,143.11C333.6,132.79,339.88,126.36,348.45,127.62Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.45,127.62c8,1.17,19.4,41.77,19.4,41.77L353.05,175S340.16,153,337,143.11C333.6,132.79,339.88,126.36,348.45,127.62Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,408.79a2.41,2.41,0,0,1-1.61-.44,1.13,1.13,0,0,1-.37-1.06.68.68,0,0,1,.37-.57c1-.48,3.63,1.2,3.93,1.4a.18.18,0,0,1,.08.2.22.22,0,0,1-.16.16A9.76,9.76,0,0,1,348,408.79ZM346.83,407a.53.53,0,0,0-.26.05.26.26,0,0,0-.14.23.81.81,0,0,0,.24.74c.44.39,1.55.44,3,.15A7.66,7.66,0,0,0,346.83,407Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.2,408.49a.16.16,0,0,1-.09,0c-.86-.47-2.47-2.34-2.24-3.29a.69.69,0,0,1,.66-.52,1.09,1.09,0,0,1,.85.25c.95.81,1,3.27,1,3.37a.23.23,0,0,1-.1.19A.27.27,0,0,1,350.2,408.49ZM348.65,405h-.09c-.26,0-.29.15-.3.2-.14.56.88,2,1.72,2.63a4.55,4.55,0,0,0-.87-2.66A.69.69,0,0,0,348.65,405Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,408.79a3.15,3.15,0,0,1-2.05-.52,1.13,1.13,0,0,1-.33-1,.7.7,0,0,1,.36-.54c1.06-.58,4.4,1.16,4.78,1.36a.19.19,0,0,1,.09.21.21.21,0,0,1-.17.17A14.91,14.91,0,0,1,304.73,408.79ZM303.27,407a.83.83,0,0,0-.38.07.29.29,0,0,0-.14.22.72.72,0,0,0,.22.65c.5.46,1.89.54,3.79.23A10.65,10.65,0,0,0,303.27,407Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.38,408.49l-.09,0c-1-.46-3-2.3-2.75-3.26,0-.23.23-.51.78-.56a1.39,1.39,0,0,1,1.1.34c1,.89,1.16,3.18,1.17,3.28a.22.22,0,0,1-.1.18A.15.15,0,0,1,307.38,408.49ZM305.46,405h-.12c-.36,0-.39.18-.4.22-.12.58,1.19,2,2.21,2.65a4.58,4.58,0,0,0-1-2.62A1,1,0,0,0,305.46,405Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.95,
    y: 222.61,
    width: 59.73,
    height: 41.84,
    rx: 4.09,
    transform: "translate(-28.49 48.61) rotate(-7.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.95,
    y: 222.61,
    width: 59.73,
    height: 41.84,
    rx: 4.09,
    transform: "translate(-28.49 48.61) rotate(-7.43)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.69,230.52a3.85,3.85,0,0,1-2.36-.81,3.92,3.92,0,0,1-1.49-2.58l-.9-6.94a3.88,3.88,0,0,1,3.35-4.35l11.55-1.51a3.89,3.89,0,0,1,4.36,3.35l.91,6.94a3.91,3.91,0,0,1-3.35,4.36h0l-11.56,1.5A4.38,4.38,0,0,1,354.69,230.52Zm10.66-14-.21,0-11.56,1.51a1.62,1.62,0,0,0-1.4,1.82l.9,6.94a1.64,1.64,0,0,0,.63,1.08,1.61,1.61,0,0,0,1.2.32l11.55-1.5a1.65,1.65,0,0,0,1.41-1.83L367,218a1.62,1.62,0,0,0-.62-1.08A1.65,1.65,0,0,0,365.35,216.55Zm1.26,11.31h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.81,
    y: 221.98,
    width: 59.73,
    height: 41.84,
    rx: 4.09,
    transform: "translate(-28.36 49.23) rotate(-7.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.52,209.87l-3.26,6.35,9.56.44a7.62,7.62,0,0,0-1.24-8.58Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.91,221.14l5.7-.78.21-3.7-9.56-.44.15,2.07A3.09,3.09,0,0,0,357.91,221.14Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.82,172.69c-.15.78.91,3.67,1.69,4.79s13.68,2.11,15.34-.43,1.73-7.06.94-8.57S351.13,171,350.82,172.69Z",
    style: {
      fill: "#066FD1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-228"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.38,141.48c-1.61,2.11-3.36,4.42-5,6.69s-3.22,4.58-4.73,6.92a89.4,89.4,0,0,0-7.81,14.21c-.25.59-.48,1.18-.68,1.77q-.16.44-.3.87l-.14.44-.06.21,0,.06a6.28,6.28,0,0,0-.11,2.34,38.53,38.53,0,0,0,1.77,7.39c1.71,5.17,4,10.5,6.25,15.67l-5.11,3.24A85.71,85.71,0,0,1,136.56,186a40.77,40.77,0,0,1-3.43-9.25,16.22,16.22,0,0,1-.24-6.34l.08-.48.08-.32.15-.62c.09-.41.19-.82.31-1.22.22-.81.46-1.59.72-2.37a85.52,85.52,0,0,1,8.14-16.81c1.6-2.59,3.24-5.13,5-7.58s3.5-4.83,5.53-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.22,196.2l5.26,2.79-6,7.09s-3.78-2.56-4-6.46Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.56 203.36 156.08 208.51 149.43 206.08 155.48 198.99 162.56 203.36",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.18,181l6.22,3.21-.55,2.24-5,5s-3.6-2.8-3.52-6.7Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.08 181.88 247.78 180.81 251.44 182.37 249 182.78 247.4 184.23 242.08 181.88",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.63,192.19l-6.18,1.33a3,3,0,0,1-1.92-.23l-3.71-1.8,5-5,3.31-1,4.14,4.75A1.22,1.22,0,0,1,253.63,192.19Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.17,100.94c.14.67.6,1.14,1,1s.68-.71.55-1.38-.61-1.14-1-1S185,100.27,185.17,100.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.71,102.09a24.54,24.54,0,0,0,4.37,5.09c-1,1.35-3.08,1.25-3.08,1.25Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,97.71a.43.43,0,0,1-.27-.11.41.41,0,0,1,0-.57,4,4,0,0,1,3.42-1.33.41.41,0,0,1-.13.8h0a3.19,3.19,0,0,0-2.7,1.08A.39.39,0,0,1,182,97.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,112.79c1.16,5.9,1.85,14.07-2.27,18,0,0,1.61,6,12.57,6,12.06,0,5.8-5.26,5.8-5.26-5-1.55-5-7.26-3.82-11.84Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,134.83c-1-1.58-.67-6.37.53-7.15,1.92-1.26,9.84-1.12,20.35,1.95-1.42,4.58.89,7.16.89,7.16Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.2,143.32c-3.75,3.7-4.84,11.28-4.43,16.45.92-1.57,1.9-3.14,2.91-4.67,1.51-2.35,3.12-4.64,4.74-6.94.45-.63.91-1.27,1.38-1.91.09-.41.17-.82.25-1.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.64,407a2.63,2.63,0,0,0,2-.11.78.78,0,0,0,.19-.89.9.9,0,0,0-.49-.56c-1.09-.52-3.6.5-3.7.54a.19.19,0,0,0-.12.17.19.19,0,0,0,.11.18A10,10,0,0,0,127.64,407Zm1.32-1.29.22.07a.52.52,0,0,1,.29.33c.1.34,0,.45-.07.49-.43.37-2,0-3.17-.43A6.22,6.22,0,0,1,129,405.68Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.68,406.32h.09c.92-.26,2.87-1.65,2.89-2.56a.62.62,0,0,0-.49-.62,1,1,0,0,0-.85.07c-1.07.55-1.75,2.78-1.78,2.87a.21.21,0,0,0,0,.19A.21.21,0,0,0,125.68,406.32Zm2.28-2.86.09,0c.23.08.23.2.23.25,0,.54-1.3,1.62-2.25,2.06a4.63,4.63,0,0,1,1.47-2.26A.64.64,0,0,1,128,403.46Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.19,408.32c1,0,2-.14,2.37-.61a.72.72,0,0,0,0-.83,1,1,0,0,0-.61-.45c-1.34-.36-4.16,1.24-4.28,1.31a.18.18,0,0,0-.09.2.19.19,0,0,0,.15.16A14.46,14.46,0,0,0,187.19,408.32Zm1.28-1.56a1.45,1.45,0,0,1,.37,0,.56.56,0,0,1,.37.27c.14.24.09.35,0,.42-.37.52-2.41.53-3.91.32A8.71,8.71,0,0,1,188.47,406.76Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.75,408.1l.08,0c1-.43,2.9-2.18,2.76-3.09,0-.22-.19-.48-.71-.54a1.45,1.45,0,0,0-1.06.33c-1,.85-1.25,3-1.26,3.11a.21.21,0,0,0,.08.17A.19.19,0,0,0,184.75,408.1Zm2-3.27h.12c.34,0,.36.17.37.21.09.55-1.22,1.92-2.21,2.51a4.46,4.46,0,0,1,1.06-2.48A1,1,0,0,1,186.72,404.83Z",
    style: {
      fill: "#066FD1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.89 407.91 183.95 407.91 184.75 389.23 176.69 389.23 175.89 407.91",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.83 404.46 124.61 406.11 131.67 388.24 123.89 386.59 116.83 404.46",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.33,405.09l-8.86-1.92a.7.7,0,0,0-.78.39l-3.08,6.67a1.19,1.19,0,0,0,.85,1.66c3.11.61,4.65.76,8.54,1.6,2.4.52,7.81,1.84,11.12,2.55s4.44-2.46,3.15-3.05c-5.78-2.64-8.2-5-9.77-7.14A1.94,1.94,0,0,0,125.33,405.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.9,407h-8.81a.72.72,0,0,0-.69.55l-1.59,7.17a1.18,1.18,0,0,0,1.16,1.44c3.18-.06,7.77-.24,11.76-.24,4.67,0,6.33.25,11.8.25,3.31,0,4.23-3.34,2.85-3.65-6.31-1.38-9.09-1.53-14.54-4.89A3.79,3.79,0,0,0,183.9,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.75 389.24 184.34 398.86 176.27 398.86 176.68 389.24 184.75 389.24",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.89 386.59 131.67 388.24 128.03 397.45 120.25 395.81 123.89 386.59",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66,202.75s-9.16,61.64-14.18,84.73c-5.5,25.29-35,109-35,109L118,393.3s20.64-68.18,25.25-103.53c3.55-27.15,10.54-87,10.54-87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66,202.75s-9.16,61.64-14.18,84.73c-5.5,25.29-35,109-35,109L118,393.3s20.64-68.18,25.25-103.53c3.55-27.15,10.54-87,10.54-87Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.93,391.61c.06,0-2.69,5.22-2.69,5.22L117,393.31l1.37-4.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.87,224.71c-10.58,2.08-9.46,41.55-8.19,61.85,3-14.35,7.52-42,10.58-61.56A3.69,3.69,0,0,0,175.87,224.71Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,202.75s1.11,60.3.23,84.9c-.91,25.58-9.84,109.35-9.84,109.35H173.68s-.5-82.27-1.11-107.4c-.66-27.39-4-86.85-4-86.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,202.75s1.11,60.3.23,84.9c-.91,25.58-9.84,109.35-9.84,109.35H173.68s-.5-82.27-1.11-107.4c-.66-27.39-4-86.85-4-86.85Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,391.56c.06,0-.78,5.67-.78,5.67H172.58l-.45-5.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,140.71c1.65,8.72,4.71,33.08-.07,68.52l-46.68-.72c-.27-6.19,4.65-39.79.1-69.62a6.44,6.44,0,0,1,5.53-7.34c2.36-.32,5.1-.62,7.8-.75a160,160,0,0,1,18.33,0c2,.19,4,.48,5.78.79A11.42,11.42,0,0,1,198.06,140.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.34,149.37l-7.86,1.95c-.6,7.34,4.24,15.65,9.08,22A210.38,210.38,0,0,0,199.34,149.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.11,136.79c1.33,2.39,2.77,5,4.25,7.43s3,4.92,4.53,7.32a97.77,97.77,0,0,0,10,13.32c.46.47.91.95,1.37,1.39l.34.33.27.24c.15.16.41.34.6.51.92.72,2,1.48,3.19,2.21,2.35,1.45,4.87,2.87,7.43,4.24,5.12,2.75,10.42,5.45,15.65,8.18l-2.07,5.69a151.11,151.11,0,0,1-17.45-5.31c-2.86-1.07-5.73-2.23-8.6-3.64a40.61,40.61,0,0,1-4.43-2.46c-.39-.28-.76-.5-1.18-.83l-.6-.46-.49-.41c-.67-.54-1.28-1.1-1.9-1.66a69.26,69.26,0,0,1-6.6-7.08c-2-2.43-3.87-5-5.64-7.49s-3.45-5.13-5-7.78-3.09-5.25-4.53-8.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.49,104.06c2.18,8.14,3,13,8.07,16.4,7.56,5.1,17-.75,17.26-9.38.26-7.76-3.35-19.77-12.08-21.41A11.49,11.49,0,0,0,162.49,104.06Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4,104.16c1.94-2.85,2.68-7.23,1.32-9.34,1.27.53,10.43,1.16,6.84-5.36s-10.79-8.32-17.06-6.52l3.05.88s-8.57-.62-12.74,2.85c1.27.07,2.37,0,2.37,0S154,91,158,94.29c-6.45,4.91-2.08,11.71,8.54,21.85,1.85,1.67,7.09,1.06,8.25.06C174.05,111.78,178.31,105.78,179.4,104.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.48,98.61c1.9,1.39,4.25,5.48,5.34,7.52s2.24,1.78,2.79,2.59,2.8,14.51.39,16.7-9.66-1.27-10.61-3.79.79-8.7,1.26-10.11a14.39,14.39,0,0,0-.42-7.32C178.39,101.81,180.48,98.61,180.48,98.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2,104.54a7.7,7.7,0,0,0,3.65,4.76c2.21,1,2.48-1.57,2.05-4-.39-2.21-1-4-2.79-4.86C177,99.35,175.47,102.12,176.2,104.54Z",
    style: {
      fill: "#ffc3bd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplier);
export default __webpack_public_path__ + "static/media/Supplier.978e9c1ceb5fb117c446e1122ac53c3a.svg";
export { ForwardRef as ReactComponent };